import { NavLink, Outlet } from "react-router-dom";

function tabClass({ isActive }: { isActive: boolean }) {
  return `rounded-md px-3 py-1.5 text-sm font-medium no-underline transition-colors ${
    isActive ? "bg-green-700 text-white" : "text-gray-700 hover:bg-gray-100"
  }`;
}

export function MgmtLayout() {
  return (
    <div>
      <h1 className="mb-4 text-3xl font-bold tracking-tight text-green-700">
        Payroll Management
      </h1>
      <nav className="mb-6 flex gap-2 border-b border-gray-200 pb-3">
        <NavLink to="window" className={tabClass}>
          Payroll Window
        </NavLink>
        <NavLink to="approvals" className={tabClass}>
          Approvals
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
